var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXBlanc = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none",
    viewBox: "0 0 43 43",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.7,
    d: "M21.436 41.341c10.953 0 19.833-8.88 19.833-19.833S32.389 1.676 21.436 1.676 1.604 10.556 1.604 21.508c0 10.954 8.879 19.833 19.832 19.833Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.097 20.317 31.288 11h-1.94l-7.116 8.088L16.553 11h-6.551l8.59 12.231L10.001 33h1.94l7.51-8.543L25.451 33h6.551zm-2.658 3.021-.872-1.218-6.924-9.688h2.98l5.59 7.821.869 1.219 7.265 10.166h-2.982z"
  })));
};
export default SvgXBlanc;